import NextImage from "@/components/global/NextImage";
import { getProductVariant } from "@/helpers/productDetails";
import { validateImgSrc } from "@/utils/global";
import { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const BundleAlbum = ({ parentProduct }) => {
  const [previewImg, setPreviewImg] = useState(null);
  const productVariant = getProductVariant(parentProduct);
  const images = useMemo(() => {
    return productVariant?._media_?.image || [];
  }, [productVariant]);

  useEffect(() => {
    setPreviewImg(images.at(0)?.image);
  }, [images]);

  return (
    <div className="p-3 border max-sm:w-fit rounded-md">
      <NextImage
        src={validateImgSrc(previewImg || images.at(0)?.image || "")}
        width={288}
        height={240}
        className="object-contain rounded-md w-72 h-60 max-sm:h-24 max-sm:min-w-28"
        alt=""
      />
      <div className="flex items-center max-sm:hidden justify-center gap-2 mt-3 overflow-x-auto">
        {images?.map((image) => (
          <NextImage
            key={uuidv4()}
            onClick={() => setPreviewImg(image?.image)}
            src={validateImgSrc(image?.image)}
            width={48}
            height={48}
            className="object-contain p-1 border rounded-md size-12 cursor-pointer"
            alt=""
          />
        ))}
      </div>
    </div>
  );
};

export default BundleAlbum;
